export default __webpack_public_path__ + "static/media/BakerAcademicLogo.aecc6751.png";